<script>
    export let data, clz = "menu component-center";
</script>

<table class="{clz}" style="text-align: center;" cellspacing="0" cellpadding="0">
    <tbody>
    <tr>
      {#each data.menu as item (item)}
          <th class="menu-item" style="padding-right: 20px; padding-left: 20px;">
              <a href={item.link}
                 style="color: {data.style.color}; font-size: 14px; text-decoration: none; pointer-events: none">{item.caption}</a>
          </th>
      {/each}
    </tr>
    </tbody>
</table>